// @flow

import Sticky from '../components/Sticky';
import Notifications from '../constants/Notifications';
import { scroll } from '../tests/TestHelpers';
import { outerHeight } from '../classes/Helpers';

export default class ReferenceSticky extends Sticky {
  #offsetFromHeader: number = 40;
  #ref: HTMLElement;
  bottomClass: string = 'bottom';
  elementHeight: number;

  /**
   * Initialize the component
   *
   * @param pEl
   */
  bind(pEl: HTMLElement): void {
    if (pEl.dataset.minWidth && window.innerWidth < JSON.parse(pEl.dataset.minWidth)) return;
    const ref: string = pEl.dataset.reference;
    if (!ref) {
      throw new Error('No reference');
    }

    const referenceElement: ?HTMLElement = document.querySelector(`[ref='${ref}']`);
    if (!referenceElement) {
      throw new Error('Reference not found');
    }
    this.#ref = referenceElement;

    super.bind(pEl);

    this.addListener(Notifications.RESIZE, this.onResize);

    const repositionOn: ?string = this.el.dataset.repositionOn;
    if (repositionOn) {
      this.addListener(Notifications[repositionOn], this.reposition);
    }
  }

  /**
   * Handle on a resize event
   */
  onResize(): void {
    const body: ?HTMLBodyElement = document.body;
    if (!body) return;

    this.reposition();
  }

  /**
   * Handle on a scroll event
   *
   * @param pData
   */
  onScroll(pData: Object): void {
    const totalElementHeight: number = this.el.offsetHeight + this.#offsetFromHeader;
    const referenceHeight: number = this.#ref.offsetHeight;

    const fullHeight: number = outerHeight(this.el);

    if (fullHeight >= this.el.parentElement.offsetHeight) {
      return;
    }

    if (totalElementHeight < referenceHeight) {
      super.onScroll(pData);
      if ((pData.scrollTop - window.store.headerHeight) >= referenceHeight - totalElementHeight) {
        this.el.classList.add(this.bottomClass);
      } else {
        this.el.classList.remove(this.bottomClass);
      }
    } else {
      this.el.classList.remove(this.bottomClass);
      this.el.classList.remove(this.class);
    }
  }

  /**
   * Repositions the element to the correct place
   */
  reposition(): void {
    scroll();
  }
}
